<template>
  <asc-page-loading-indicator
    :loading="isDataLoading && apiPageFailure.length === 0"
  >
    <div class="asc-custom-alerts-container">
      <v-container fluid>
        <asc-page-coming-soon
          label="Custom Analytics Page Coming Soon!"
        ></asc-page-coming-soon>
      </v-container>
    </div>
  </asc-page-loading-indicator>
</template>

<script>
import { mapState } from 'vuex'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import AscPageComingSoon from '@/components/molecules/AscPageComingSoon'

export default {
  name: 'AscCustomAlertsContainer',

  components: {
    AscPageLoadingIndicator,
    AscPageComingSoon,
  },

  data: function () {
    return {
      isSticky: false,
      isDataLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
  },

  mounted() {
    this.parentElement.addEventListener('scroll', this.handlePageScroll, false)
    window.addEventListener('resize', this.handlePageResize)
  },

  methods: {
    handlePageScroll() {
      const scrollTop = this.parentElement.scrollTop
      const elementOffset = this.getElementOffset(this.$el)
      const offsetDifference = elementOffset.top + 1

      if (offsetDifference <= scrollTop && !this.isSticky) {
        this.isSticky = true
      } else if (offsetDifference > scrollTop && this.isSticky) {
        this.isSticky = false
      }
    },
    handlePageResize() {
      this.isSticky = false
      this.$nextTick(() => {
        this.handlePageScroll()
      })
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts-container {
  background-color: $gray-100;

  & .container {
    padding: 16px;
  }
}
</style>
